import API from "../../../app/api";

export const getNewArrivals = async () => {
  try {
    const res = await API.get("/banners");

    if (res.data?.success) {
      return res.data?.data?.["new-arrivals"]?.banners || [];
    }

    return [];
  } catch (error) {
    console.error("New Arrivals Error:", error);
    return [];
  }
};